const { CONSTANTS } = require('../../config')

/**
 * @param {number|string} value
 * @param {string} [country]
 * @param {string} [locale]
 * @param {number} decimals
 * @returns {string|undefined}
 */
function number (value, country = '', locale = '', decimals = 2) {
  if (!value && value !== 0) return ''

  let val = value
    .toString()
    .replace(/[^0-9,.]+/g, '')
    .replace(',', '.')

  if (!val) return ''
  val = parseFloat(val).toFixed(decimals)

  const defaultLocale = CONSTANTS[country?.toUpperCase()]?.LOCALE
  const decimalSign = CONSTANTS[country?.toUpperCase()]?.NUMBERS?.[locale || defaultLocale]?.decimalSign ?? CONSTANTS.DECIMAL_SIGN
  const thousandSeparator = CONSTANTS[country?.toUpperCase()]?.NUMBERS?.[locale || defaultLocale]?.thousandSeparator ?? CONSTANTS.THOUSAND_SEPARATOR

  return val
    .toString()
    .replace(/\d(?=(?:\d{3})+(?!\d))/g, '$& ')
    .replace('.00', '')
    .replace('.', decimalSign)
    .replace(/\s/g, thousandSeparator)
}

module.exports = { number }
